import { Provider } from '@angular/core';

import { EVALUATION_REPOSITORY } from '@/domain/repositories/evaluation/evaluation.repository.contract';
import { EvaluationRepositoryImpl } from '@/repositories/evaluation/evaluation.repository';

export const evaluationRepositoryProvider: Provider = {
  provide: EVALUATION_REPOSITORY,
  useClass: EvaluationRepositoryImpl
};
